<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-21 11:19:05
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>证件详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div style="display: flex; justify-content: space-between">
          <div>
            <div class="infoItem">用户名：{{ info.name }}</div>
            <div class="infoItem">手机号：{{ info.phone }}</div>
            <div class="infoItem">证件类型：{{ info.careerTypeName }}</div>
            <div class="infoItem">证件等级：{{ info.levelTypeName }}</div>
            <div class="infoItem">证件编号：{{ info.certNumber }}</div>
            <div class="infoItem" style="display: flex; align-items: center">
              <el-image
                style="width: 200px; height: 300px; margin-right: 30px"
                :src="secureImageUrl"
                alt=""
                :preview-src-list="[secureImageUrl]"
              ></el-image>
              <el-image
                style="width: 200px; height: 300px"
                :src="secureImageUrl1"
                alt=""
                :preview-src-list="[secureImageUrl1]"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.askariData(),
      info: "",
    };
  },
  created() {},
  computed: {
    secureImageUrl() {
      // 如果应用运行在 HTTPS 下，则强制转换为 HTTPS
      return this.info.certFrontUrl.replace(/^http:/, "https:");
    },
    secureImageUrl1() {
      // 如果应用运行在 HTTPS 下，则强制转换为 HTTPS
      return this.info.certOppositeUrl.replace(/^http:/, "https:");
    },
  },
  mounted() {
    if (this.$route.query.info) {
      this.info = JSON.parse(this.$route.query.info);
      console.log(this.info);
    }
  },
  methods: {},
};
</script>
<style scoped>
.infoItem {
  margin-bottom: 10px;
}
</style>
